import { render, staticRenderFns } from "./b-ticket-wrap.vue?vue&type=template&id=cafa8fc4&scoped=true"
import script from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
export * from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-wrap.vue?vue&type=style&index=0&id=cafa8fc4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa8fc4",
  null
  
)

export default component.exports